<template>
  <div>
    <h4>Listado de tipos de solicitud</h4>
    <div class="text-right">
      <b-button @click="agregar">Agregar</b-button>
    </div>
    <br />
    <div class="table-responsive">    
      <table class="table table-condensed">
        <thead>
          <th>Tipo de solicitud</th>
          <th></th>
        </thead>
        <tr v-for="elemento in listado" :key="elemento.id_solicitud">
          <td>{{ elemento.tiposolicitud }}</td>
          <td>
            <a href="javascript:;" @click="editar(elemento)">
              <font-awesome-icon size="lg" icon="edit" />
            </a>
            <a href="javascript:;" @click="eliminar(elemento)">
              <font-awesome-icon size="lg" icon="trash" />
            </a>
          </td>
        </tr>
      </table>
    </div>
    <b-modal ref="detalle" v-bind:title="titulo">
      <p class="text-justify">
        <b>Proporciona los datos del tipo de solicitud</b>
      </p>
      <div class="form-row grupo">
        <div class="form-group col-md-12">
          <label>Tipo de solicitud</label>
          <input
            maxlength="100"
            style="max-width: 500px"
            v-model.trim="actual.tiposolicitud"
            class="form-control"
            :class="estatus($v.actual.tiposolicitud)"
          />
          <div class="errores" v-if="!$v.actual.tiposolicitud.required">Requerido</div>
        </div>
      </div>
      <template #modal-footer="{ hide }">
        <b-button variant="primary" class="float-right" @click="guardar()">
          Guardar
        </b-button>
        <b-button class="float-right" @click="hide()"> Cerrar </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import api from "@/api";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Estatus",
  data() {
    return {
      titulo: "Agregar tipo de solicitud",
      listado: [],
      usuarios: [],
      buscando: false,
      actual: {},
    };
  },
  validations() {
    return {
      actual: {
        tiposolicitud: {
          required,
        },

      },
    };
  },
  methods: {
    agregar() {
      this.titulo = "Agregar tipo de solicitud";
      this.actual = {};
      this.$refs.detalle.show();
    },
    editar (elemento) {
      this.titulo = "Editar tipo de solicitud",
      this.actual = Object.assign({}, elemento);
      this.$refs.detalle.show();
    },
    eliminar (elemento) {
      if (confirm("Confirma eliminar el tipo de solicitud: "+elemento.tiposolicitud)) {
        api.eliminarTipoSolicitud(elemento.id_tiposolicitud)
          .then((resp) => {
            let r = resp.data;
            if (r.respuesta) {
              this.actualizaTipoSolicitud();
            } else {
              this.$parent.aviso(r.mensaje);
            }
          })
          .catch((error) => {this.$parent.aviso("No se pudo eliminar "+error);});
      }
    },
    guardar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        api
          .guardarTipoSolicitud(this.actual)
          .then((resp) => {
            let r = resp.data;
            if (r.respuesta) {
              this.$refs.detalle.hide();
              this.actualizaTipoSolicitud();
            } else {
              this.$parent.error("Error al guardar la información "+r.mensaje);
            }
          })
          .catch((error) => {
              this.$parent.error("Error al guardar la información "+error);
          });
      } else {
        this.$parent.error("Información incompleta");
        this.listado = [];
        this.buscando = false;
      }
    },
    abrirDetalle() {
      this.$refs.detalle.show();
    },
    actualizaTipoSolicitud() {
      api.listarTipoSolicitud().then((r) => {
        this.listado = r.data;
      });
    },
    estatus(validation) {
      if (validation.$dirty && !validation.$error) return "dirty";
      return "error";
    },
  },
  mounted() {
    this.actualizaTipoSolicitud();
  },
};
</script>

